module.exports = __webpack_public_path__ + "static/media/Datasaur-Logo.0dc2e6ce.jpg";